import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import useRequest from '../../../../../hooks/useRequest';
import { brsHoCodeSelAPI } from '../../../../../api/progressLearningAPI';

function HoSelectBox({
  defaultValue,
  stepCode,
  handleCodeSet
}) {
  const [open, setOpen] = useState(false);
  const [ho, setHo] = useState("");
  const [hoCodeSel, code, , onReset] = useRequest((sCode) => brsHoCodeSelAPI(sCode))

  useEffect(() => {
    if (defaultValue) setHo(defaultValue);
  }, [defaultValue])

  useEffect(() => {
    if (defaultValue) setHo(defaultValue);
    else setHo("");
    
    if (!stepCode) {
      onReset();
      return;
    };
    hoCodeSel(stepCode);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stepCode, setHo]);

  const handleOnOffClick = () => {
    setOpen(!open)
  };

  const handleHoClick = (value) => {
    if (value) setHo(value);
    handleOnOffClick();
    handleCodeSet('ho', value);
  }

  return (
    <div className="area">
      <div
        className={
          clsx('new-select m_40', open && 'opened')
        }
      >
        <div
          className={clsx({
            "selected_txt": true,
            "first": ho === ""
          })}
          onClick={handleOnOffClick}
        >
          {ho !== "" ? <span>{ho}호</span> : "호"}
        </div>
        <div className="select_option">
          <ul>
            <li>
              <button
                type="button"
                className={ho === "" ? "selected" : ''}
                onClick={() => handleHoClick("")}
              >
                호
              </button>
            </li>
            {
              code && (
                code.brsEditionCdList.map((item) => (
                  <li key={item}>
                    <button
                      type="button"
                      className={ho === item ? "selected" : ''}
                      onClick={() => handleHoClick(item)}
                    >
                      {item}호
                    </button>
                  </li>
                ))
              )
            }
          </ul>
        </div>
      </div>
    </div>
  );
}

export default HoSelectBox;